import { render, staticRenderFns } from "./SupplierState.vue?vue&type=template&id=6a989a7e"
import script from "./SupplierState.vue?vue&type=script&lang=js"
export * from "./SupplierState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports